import React, { Component } from 'react';

import './App.css';
import { mobile } from './question/devops';
import ProjectWizardBase from './projectwizard-base';

const ProjectWizardOps = props => {
  console.warn(props.setAvailable);
  return <ProjectWizardBase questions={mobile} />;
};

export default ProjectWizardOps;
